<template>
  <div>
    <v-row class="justify-end mr-1">
      <template v-for="(actionItem, actionName) in appointmentActions">
        <appointment-action-group-item
          v-if="!actionItem.isShowMoreOption"
          :key="`action-${actionName}`"
          :action-item="actionItem"
          :action-name="actionName"
          @click="handleClick"></appointment-action-group-item>
      </template>
      <v-menu
        offset-y
        :internal-activator="true"
        :close-on-click="true"
        v-if="isShowMoreMenuVisible">
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: onTooltip, attrs }">
              <v-btn icon v-bind="attrs" v-on="{ ...onTooltip, ...onMenu }">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>More Options</span>
          </v-tooltip>
        </template>
        <v-list>
          <template v-for="(actionItem, actionName) in appointmentActions">
            <v-list-item
              v-if="actionItem.isShowMoreOption"
              class="account-option"
              :key="`action-${actionName}`">
              <appointment-action-group-item
                :action-item="actionItem"
                :action-name="actionName"
                @click="handleClick"></appointment-action-group-item>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-row>
    <share-appointment-dialog
      :external-activator="true"
      :show-dialog="showShareDialog"
      :appointment="appointment"
      @close="showShareDialog = false">
    </share-appointment-dialog>
    <reschedule-appointment-dialog
      :appointment-warehouse="appointmentWarehouse"
      :external-activator="true"
      :show-dialog="showRescheduleDialog"
      :appointment="appointment"
      @close="showRescheduleDialog = false">
    </reschedule-appointment-dialog>
    <edit-appointment-dialog
      :external-activator="true"
      :show-dialog="showEditDialog"
      :appointment="appointment"
      @close="showEditDialog = false">
    </edit-appointment-dialog>
    <cancel-appointment-dialog
      ref="cancelAppointment"
      @confirm="$emit('confirm')"
      :external-activator="true"
      :show-dialog="showConfirmDialog"
      :appointment="appointment"
      @close="showConfirmDialog = false">
    </cancel-appointment-dialog>
    <printable-appointment-details :appointment="appointment" :settings="settings">
    </printable-appointment-details>
  </div>
</template>

<script>
import appointmentMixin from '@/components/mixins/appointmentMixin';
import AppointmentActionGroupItem from '@satellite/modules/appointments/components/AppointmentActionGroupItem';
import { isObject } from 'class-validator';

/**
 * @displayName Appointment Action Group
 */
export default {
  components: { AppointmentActionGroupItem },
  mixins: [appointmentMixin],
  props: {
    appointment: {
      type: Object,
      required: true
    },
    /**
     * Appointment actions to show
     * {icon: 'printer', action: 'open-dialog', show: true}
     */
    appointmentActions: {
      type: Object,
      required: true
    },
    appointmentWarehouse: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  computed: {
    isShowMoreMenuVisible() {
      return (
        isObject(this.appointmentActions) &&
        Object.values(this.appointmentActions)?.some(a => a?.isShowMoreOption)
      );
    },
    settings() {
      return this.$consolidatedSettings;
    }
  },
  data() {
    return {
      printing: false,
      showShareDialog: false,
      showRescheduleDialog: false,
      showEditDialog: false,
      showConfirmDialog: false,
      showCreateAppointmentDialog: false,
      showCreateRecurringSeriesDialog: false,
      showDeleteRecurringSeriesDialog: false
    };
  },
  methods: {
    openShareDialog() {
      this.showShareDialog = true;
    },
    openCreateRecurringSeriesDialog() {
      this.showCreateRecurringSeriesDialog = true;
    },
    openDeleteRecurringSeriesDialog() {
      this.showDeleteRecurringSeriesDialog = true;
    },
    openCreateAppointmentDialogForClone() {
      this.showCreateAppointmentDialog = true;
    },
    openRescheduleDialog() {
      this.showRescheduleDialog = true;
    },
    openEditDialog() {
      this.showEditDialog = true;
    },
    openPrintTab() {
      this.$nextTick(() => {
        let domClone = document.getElementById('appointment-details-printable').cloneNode(true);

        let $printContent = document.getElementById('print-content');
        if (!$printContent) {
          $printContent = document.createElement('section');
          $printContent.id = 'print-content';
          document.body.appendChild($printContent);
        }

        $printContent.innerHTML = '';
        $printContent.appendChild(domClone);
        window.print();
      });
    },
    handleClick(action) {
      this[action]();
    }
  }
};
</script>
